export default "__VITE_ASSET__CSX$myBz__"